<template>
    <div class="fill-height pt-5">
        <v-row>
            <v-col cols="12" class="py-0">
                <span class="title">Employees overview</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <!-- <v-card> -->
                    <!-- <v-card-title> -->
                    <!-- </v-card-title> -->
                    <!-- <v-card-text> -->
                    <v-row dense>
                        <v-col cols="auto" class="py-0" align-self="center">
                            <h3>Criteria : </h3>
                        </v-col>
                        <v-col cols="3">
                            <!-- users -->
                            <v-autocomplete
                                item-value="id"
                                item-text="name"
                                multiple
                                v-model="userIds"
                                :disabled="loading"
                                :return-object="false"
                                label="Employees"
                                dense
                                outlined
                                filled
                                hide-details
                                class="rounded-lg"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="2">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fromDate"
                                        label="From"
                                        :disabled="loading"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                        dense
                                        outlined
                                        filled
                                        hide-details
                                        class="rounded-lg"
                                    />
                                </template>
                                <v-date-picker @input="menu1 = false" :disabled="loading" v-model="fromDate">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="toDate"
                                        label="To"
                                        :disabled="loading"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-on="on"
                                        dense
                                        outlined
                                        filled
                                        hide-details
                                        class="rounded-lg"
                                    />
                                </template>
                                <v-date-picker @input="menu2 = false" :disabled="loading" v-model="toDate">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto">
                            <v-btn 
                                color="green-color white--text" 
                                class="text-none rounded-lg" 
                                @click="search"
                            >
                                Generate
                            </v-btn>
                        </v-col>
                    </v-row>
                    <!-- </v-card-text> -->
                    <!-- <v-divider /> -->
                    <!-- <v-card-actions> -->
                        <!-- <v-spacer /> -->
                        
                    <!-- </v-card-actions> -->
                <!-- </v-card> -->
            </v-col>
            <v-col cols="12">
                <v-data-table :headers="headers" :items="tasks" :loading="loading" show-expand single-expand
                    :expanded.sync="expanded" item-key="user_id" class="elevation-1 rounded-lg">
                    <template v-slot:top>
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <p class="pr-4 pt-4">
                                <b>Total hours:</b> {{ totalHours.toFixed(2) }} hours
                            </p>
                        </div>
                    </template>
                    <template v-slot:item.hours="{ item }">
                        {{ item.hours.toFixed(2) }} hours
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Project</th>
                                            <th>Hours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="project in item.projects" :key="project.project_id">
                                            <td>{{ project.project.name }}
                                            <td>{{ project.hours.toFixed(2) }} hours</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </td>
                    </template>
                </v-data-table>

                <v-card v-if="0">
                   <v-card-text class="px-0">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <p class="pr-4 mb-0">
                                <b>Total hours:</b> {{ totalHours.toFixed(2) }} hours
                            </p>
                        </div>
                        <bee-handy-table
                            :headers="headers"
                            :items="[]"
                            elevation="0"
                            dense
                            zebra
                            pagination-on-scroll
                        ></bee-handy-table>
                    </v-card-text> 
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
// import eventBus from '../../../event-bus';
// import { mapState, mapGetters } from 'vuex';
// import store from '../../../store';
// import { nonDeleted } from '../../../helpers';

export default {
	data: () => ({
		userIds: null,
		fromDate: null,
		toDate: null,
		leaves: null,
		divider: null,
		loading: false,
		menu1: false,
		menu2: false,
		tasks: [],
		totalHours: 0,
		dailyHours: 0,
		dailyHoursWithoutLeaves: 0,

		expanded: [],

		headers: [
			{ text: 'Employee', value: 'user.name', sortable: false },
			{ text: 'Hours', value: 'hours' },
			{ text: '', value: 'data-table-expand' }
		]
	}),

	methods: {
		search () {
		// 	this.loading = true
		// 	store.dispatch('stats/fetchEmployeeOverviewStats', {
		// 		user_ids: this.userIds,
		// 		from_date: this.fromDate,
		// 		to_date: this.toDate
		// 	}).then(data => {
		// 		this.tasks = data.users
		// 		this.totalHours = data.total_hours
		// 		this.loading = false
		// 		this.dialog = false
		// 	})
		}

		// nonDeleted
	},

	computed: {
		// ...mapState({
		// 	users: state => state.users.users,
		// })
	},

	// mounted () {
	// 	Date.prototype.formatDDMMYYYY = function () {
	// 		return this.getDate() +
	// 			"/" + (this.getMonth() + 1) +
	// 			"/" + this.getFullYear();
	// 	}
	// },

	async beforeRouteEnter (to, from, next) {
	// await store.dispatch('users/fetchAll');
		next()
	}
}
</script>
<style scoped>
.bee-handy-table {
    box-shadow: none;
}
</style>
